'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_shopping$package$StoreId$() {
  this.a9U = 0;
  this.a9V = 0;
  $n_Lmealorama_shopping$package$StoreId$ = this;
  $m_Lmealorama_shopping$package$StoreId$();
  this.a9U = 0;
  this.a9V = 0;
}
export { $c_Lmealorama_shopping$package$StoreId$ as $c_Lmealorama_shopping$package$StoreId$ };
$p = $c_Lmealorama_shopping$package$StoreId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_shopping$package$StoreId$;
/** @constructor */
function $h_Lmealorama_shopping$package$StoreId$() {
}
export { $h_Lmealorama_shopping$package$StoreId$ as $h_Lmealorama_shopping$package$StoreId$ };
$h_Lmealorama_shopping$package$StoreId$.prototype = $p;
var $d_Lmealorama_shopping$package$StoreId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_shopping$package$StoreId$, "mealorama.shopping$package$StoreId$", ({
  LW: 1
}));
export { $d_Lmealorama_shopping$package$StoreId$ as $d_Lmealorama_shopping$package$StoreId$ };
var $n_Lmealorama_shopping$package$StoreId$;
function $m_Lmealorama_shopping$package$StoreId$() {
  if ((!$n_Lmealorama_shopping$package$StoreId$)) {
    $n_Lmealorama_shopping$package$StoreId$ = new $c_Lmealorama_shopping$package$StoreId$();
  }
  return $n_Lmealorama_shopping$package$StoreId$;
}
export { $m_Lmealorama_shopping$package$StoreId$ as $m_Lmealorama_shopping$package$StoreId$ };
//# sourceMappingURL=mealorama.shopping$package$-Store-Id$.js.map
